import { createSelector } from "reselect";

// Actions

export const REQUEST_PRODUCTS = "REQUEST_PRODUCTS";
export const RECEIVE_PRODUCTS = "RECEIVE_PRODUCTS";
export const LOADED_PRODUCTS = "LOADED_PRODUCTS";
export const SET_SORT_BY = "SET_SORT_BY";

export function requestProducts() {
    return {
        type: REQUEST_PRODUCTS
    }
}

export function receiveProducts(products) {
    return {
        type: RECEIVE_PRODUCTS,
        products: products
    }
}

export function loadedProducts() {
    return {
        type: LOADED_PRODUCTS
    }
}

export function fetchProducts(apiUrl) {
    return dispatch => {
        dispatch(requestProducts);
        const loadData = (apiUrl) => {
            let req = new XMLHttpRequest();
            req.addEventListener("load", () => {
                let p = JSON.parse(req.responseText);
                if(p.hasOwnProperty("d")) {
                    p = p.d;
                }
                dispatch(receiveProducts(p))
            });
            req.addEventListener("loadend", () => {
                dispatch(loadedProducts());
            })
            req.open("POST", apiUrl);
            req.setRequestHeader("Content-Type", "application/json");
            let regionCode = document.getElementById("currentsitelanguage").innerText;
            req.send(JSON.stringify({ regionCode: regionCode }));
        }

        return loadData(apiUrl);
    }
}

export function setSortBy(sort) {
    return {
        type: SET_SORT_BY,
        sort
    }
}

// Reducers
export function products(state = {isFetching: true, products: [], sortBy: null}, action) {
    switch(action.type) {
        case REQUEST_PRODUCTS:
            return {...state, isFetching: true};
        case RECEIVE_PRODUCTS:
            return {...state, products: action.products};
        case LOADED_PRODUCTS:
            return {...state, isFetching: false}
        case SET_SORT_BY:
            return {...state, sortBy: action.sort}
        default:
            return state;
    }
}

// Selectors
export const selectFilteredProducts = createSelector(
    state => state.filters.filters,
    state => state.products.products,
    state => state.products.sortBy,
    (filters, products, sortBy) => {
        let filteredProducts = getFilteredProducts(products, filters);
        if (sortBy) {
            return sortBy.sort(filteredProducts);
        } else {
            return filteredProducts;
        }
    }
)

export const selectFilteredProductsCount = createSelector(
    selectFilteredProducts,
    filteredProducts => filteredProducts.length
)

// Helpers

export function getMinMax(products, dataPoint) {
    let minMax = [0,0]
    let isOptionArray = Array.isArray(products[0][dataPoint]);
    if (isOptionArray) {
        products.forEach(product => {
            product[dataPoint].forEach(op => {
                if (op < minMax[0] || minMax[0] === 0) minMax[0] = Math.floor(op);
                if (op > minMax[1] || minMax[1] === 0) minMax[1] = Math.ceil(op);
            });
        })
    } else {
        let initialised = false;
        products.forEach(product => {
            let op = product[dataPoint];  
            if (!initialised) {
                if (op > 0) {
                    minMax[0] = Math.floor(op * 10000) / 10000;
                    initialised = true;
                }                    
            } else {
                if (op <= minMax[0]) minMax[0] = Math.floor(op * 10000) / 10000;
            }                     
            if (op > minMax[1] || minMax[1] === 0) minMax[1] = Math.ceil(op * 10000) / 10000;
        })
    }
    // console.log("minMax", dataPoint, minMax)
    return minMax;
}

export function getFilteredProducts(products, filters) {
    let filteredProducts = [];

    for (let productIndex = 0; productIndex < products.length; productIndex++) {
        let product = products[productIndex];
        let filtersPassed = [];

        for(let categoryId in filters) {
            let filter = filters[categoryId];
            let filterPasses = filter.productPassesFilter(product);
            if(filterPasses !== undefined) filtersPassed.push(filterPasses);
        }
        if (filtersPassed.every(val => val)) filteredProducts.push(product);
    }

    return filteredProducts;
}